import { Button, Modal } from '@birdi/components-common';
import { css } from '@emotion/react';
import { BirdiTheme } from '@birdi/theme';
import WarningSVG from '@birdi/icons/warning.svg';
import { mapFolders as mapFoldersApi, stroot } from '@birdi/js-sdk';

interface Folder {
  id: string;
  name: string;
}

interface DeleteFolderModalProps {
  open: boolean;
  onChange: (value: boolean) => void;
  selectedFolder: Folder;
  onFolderDeleted: () => void;
}

export const DeleteFolderModal = ({ open, onChange, selectedFolder, onFolderDeleted }: DeleteFolderModalProps) => {

  const handleDelete = async () => {
    if (selectedFolder) {
      const response = await mapFoldersApi.deleteFolder(stroot('eih3da'), selectedFolder.id);
      if (response.status === 200) {
        onFolderDeleted();
      }
    }
    onChange(false);
  }

  return (
    <Modal.Root open={open} onOpenChange={onChange}>
      <Modal.Header>
        <div
          css={css`
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.75rem;
          `}
        >
          <WarningSVG
            css={(theme: BirdiTheme) => css`
              width: 2rem;
              height: 2rem;
            `}
          />
          <span css={css` font-size: 1.25rem; font-weight: normal;`}>
            <strong>Warning:</strong> Delete a folder
          </span>
        </div>
      </Modal.Header>

      <Modal.Body>
        <div
          css={css`
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            gap: 1rem;
            font-size: 1.15rem;
          `}
        >
          <p css={css`margin: 0; line-height: 1.5; text-align: center;`}>
            You're about to delete the "<strong>{selectedFolder.name}</strong>" folder. The maps <br /> will remain safe, just unassigned.
          </p>
          <p css={css`margin: 0; font-weight: bold; line-height: 1.5; text-align: center;`}>
            Are you sure you want to continue?
          </p>
        </div>
      </Modal.Body>

      <Modal.Footer buttons>
        <div
          css={css`
            display: flex;
            justify-content: center;
            gap: 1rem;
            width: 100%;
          `}
        >
          <Button variant='solid' onClick={() => onChange(false)}>
            Cancel
          </Button>
          <Button variant='outline' onClick={handleDelete}>
            Yes, delete folder
          </Button>
        </div>
      </Modal.Footer>
    </Modal.Root>
  );
};
